export var PropertyDataTypeEnum;
(function (PropertyDataTypeEnum) {
    PropertyDataTypeEnum[PropertyDataTypeEnum["Text"] = 1] = "Text";
    PropertyDataTypeEnum[PropertyDataTypeEnum["Code"] = 2] = "Code";
    PropertyDataTypeEnum[PropertyDataTypeEnum["Boolean"] = 3] = "Boolean";
    PropertyDataTypeEnum[PropertyDataTypeEnum["Option"] = 4] = "Option";
    PropertyDataTypeEnum[PropertyDataTypeEnum["LargeText"] = 5] = "LargeText";
    PropertyDataTypeEnum[PropertyDataTypeEnum["Action"] = 6] = "Action";
    PropertyDataTypeEnum[PropertyDataTypeEnum["Role"] = 7] = "Role";
    PropertyDataTypeEnum[PropertyDataTypeEnum["RoleComboBox"] = 8] = "RoleComboBox";
    PropertyDataTypeEnum[PropertyDataTypeEnum["SerieComboBox"] = 9] = "SerieComboBox";
    PropertyDataTypeEnum[PropertyDataTypeEnum["SubserieComboBox"] = 10] = "SubserieComboBox";
    PropertyDataTypeEnum[PropertyDataTypeEnum["InlineJavaScriptEditor"] = 11] = "InlineJavaScriptEditor";
    PropertyDataTypeEnum[PropertyDataTypeEnum["InlineJsonEditor"] = 12] = "InlineJsonEditor";
    PropertyDataTypeEnum[PropertyDataTypeEnum["InlineXmlEditor"] = 13] = "InlineXmlEditor";
    PropertyDataTypeEnum[PropertyDataTypeEnum["InlineSqlEditor"] = 14] = "InlineSqlEditor";
    PropertyDataTypeEnum[PropertyDataTypeEnum["CustomForm"] = 15] = "CustomForm";
    PropertyDataTypeEnum[PropertyDataTypeEnum["Color"] = 16] = "Color";
    PropertyDataTypeEnum[PropertyDataTypeEnum["Keywords"] = 17] = "Keywords";
    PropertyDataTypeEnum[PropertyDataTypeEnum["Rule"] = 18] = "Rule";
    PropertyDataTypeEnum[PropertyDataTypeEnum["BooleanWithRule"] = 19] = "BooleanWithRule";
})(PropertyDataTypeEnum || (PropertyDataTypeEnum = {}));
